<template>
	<v-sheet elevation="0">
		<v-sheet elevation="0" max-width="600px">
			<table class="show-dialog-table">
				<tbody>
					<ShowDetailRecord :columnName="'工事名'" :value="'XXX'" />
					<ShowDetailRecord :columnName="'状態'" :value="'XXX'" />
				</tbody>
			</table>
		</v-sheet>

		<v-tabs class="mt-4" v-model="tab" height="40px" slider-color="primary" color="black">
			<v-tab> 証明書部分 </v-tab>
			<v-tab> 客先情報記入欄 </v-tab>
			<v-tab> 作業時間 </v-tab>
		</v-tabs>
		<v-tabs-items v-model="tab" class="pa-2">
			<v-tab-item>
				<h6 class="text-body-1 font-weight-bold">証明書</h6>
				<v-sheet elevation="0">
					<v-row no-gutters>
						<v-col class="mt-4 px-1" cols="12" md="6">
							<table class="show-dialog-table" width="100%">
								<tbody>
									<!-- TODO: 必須項目にrules追加・それぞれカラムの型に合うinputにする -->
									<ShowDetailRecord :columnName="'工事名'">
										<template v-slot:value>
											<template v-if="type == 'edit'">
												<v-text-field v-model="TODO" hide-details dense outlined />
											</template>
											<template v-else-if="type == 'show'">{{ "XXX" }}</template>
										</template>
									</ShowDetailRecord>
									<ShowDetailRecord :columnName="'工事内容'">
										<template v-slot:value>
											<template v-if="type == 'edit'">
												<v-textarea rows="1" auto-grow v-model="TODO" hide-details dense outlined />
											</template>
											<template v-else-if="type == 'show'">{{ "XXX" }}</template>
										</template>
									</ShowDetailRecord>
									<ShowDetailRecord :columnName="'施工場所'">
										<template v-slot:value>
											<template v-if="type == 'edit'">
												<v-text-field v-model="TODO" hide-details dense outlined />
											</template>
											<template v-else-if="type == 'show'">{{ "XXX" }}</template>
										</template>
									</ShowDetailRecord>
									<ShowDetailRecord :columnName="'工事期間'">
										<template v-slot:value>
											<template v-if="type == 'edit'">
												<v-row no-gutters align="center">
													<v-col cols="5">
														<v-menu
															close-on-content-click
															transition="scale-transition"
															offset-y
															min-width="auto"
														>
															<template v-slot:activator="{ on, attrs }">
																<v-text-field
																	v-model="TODO"
																	readonly
																	outlined
																	dense
																	hide-details
																	v-bind="attrs"
																	v-on="on"
																/>
															</template>
															<v-date-picker v-model="TODO" no-title locale="ja-JP" />
														</v-menu>
													</v-col>
													<v-col cols="2" class="text-center">〜</v-col>
													<v-col cols="5">
														<v-menu
															close-on-content-click
															transition="scale-transition"
															offset-y
															min-width="auto"
														>
															<template v-slot:activator="{ on, attrs }">
																<v-text-field
																	v-model="TODO"
																	readonly
																	outlined
																	dense
																	hide-details
																	v-bind="attrs"
																	v-on="on"
																/>
															</template>
															<v-date-picker v-model="TODO" no-title locale="ja-JP" />
														</v-menu>
													</v-col>
												</v-row>
											</template>
											<template v-else-if="type == 'show'">{{
												"XXXX/XX/XX ~ XXXX/XX/XX"
											}}</template>
										</template>
									</ShowDetailRecord>
									<ShowDetailRecord :columnName="'工事完了日'">
										<template v-slot:value>
											<template v-if="type == 'edit'">
												<v-menu
													close-on-content-click
													transition="scale-transition"
													offset-y
													min-width="auto"
												>
													<template v-slot:activator="{ on, attrs }">
														<v-text-field
															v-model="TODO"
															readonly
															outlined
															dense
															hide-details
															v-bind="attrs"
															v-on="on"
														/>
													</template>
													<v-date-picker v-model="TODO" no-title locale="ja-JP" />
												</v-menu>
											</template>
											<template v-else-if="type == 'show'">{{ "XXXX/XX/XX" }}</template>
										</template>
									</ShowDetailRecord>
								</tbody>
							</table>
						</v-col>
						<v-col class="mt-4 px-1" cols="12" md="6">
							<table class="show-dialog-table" width="100%">
								<tbody>
									<ShowDetailRecord :columnName="'工事責任者'">
										<template v-slot:value>
											<template v-if="type == 'edit'">
												<v-text-field v-model="TODO" hide-details dense outlined />
											</template>
											<template v-else-if="type == 'show'">{{ "XXX X" }}</template>
										</template>
									</ShowDetailRecord>
									<ShowDetailRecord :columnName="'製番'">
										<template v-slot:value>
											<template v-if="type == 'edit'">
												<v-text-field v-model="TODO" hide-details dense outlined />
											</template>
											<template v-else-if="type == 'show'">{{ "2023XXXXXX" }}</template>
										</template>
									</ShowDetailRecord>
									<ShowDetailRecord :columnName="'整理番号'">
										<template v-slot:value>
											<template v-if="type == 'edit'">
												<v-text-field v-model="TODO" hide-details dense outlined />
											</template>
											<template v-else-if="type == 'show'">{{ "XXXXXX" }}</template>
										</template>
									</ShowDetailRecord>
									<ShowDetailRecord :columnName="'管理番号'">
										<template v-slot:value>
											<template v-if="type == 'edit'">
												<v-text-field v-model="TODO" hide-details dense outlined />
											</template>
											<template v-else-if="type == 'show'">{{ "XXXXXXX" }}</template>
										</template>
									</ShowDetailRecord>
									<ShowDetailRecord :columnName="'作業工数'">
										<template v-slot:value>
											<template v-if="type == 'edit'">
												<v-text-field v-model="TODO" hide-details dense outlined />
											</template>
											<template v-else-if="type == 'show'">{{ "XXX" }}</template>
										</template>
									</ShowDetailRecord>
									<ShowDetailRecord :columnName="'営業担当者'">
										<template v-slot:value>
											<template v-if="type == 'edit'">
												<v-text-field v-model="TODO" hide-details dense outlined />
											</template>
											<template v-else-if="type == 'show'">{{ "XXX XX" }}</template>
										</template>
									</ShowDetailRecord>
								</tbody>
							</table>
						</v-col>
					</v-row>
				</v-sheet>
			</v-tab-item>

			<v-tab-item>
				<h6 class="text-body-1 font-weight-bold">客先情報記入欄</h6>
				<v-sheet class="mt-4" max-width="" elevation="0">
					<v-row no-gutters>
						<v-col class="px-1" cols="12" md="6">
							<table class="show-dialog-table" width="100%">
								<tbody>
									<ShowDetailRecord :columnName="'現地着任時'">
										<template v-slot:value>
											<template v-if="type == 'edit'">
												<v-text-field v-model="TODO" hide-details dense outlined />
											</template>
											<template v-else-if="type == 'show'">{{ "XXXXXXX" }}</template>
										</template>
									</ShowDetailRecord>
									<ShowDetailRecord :columnName="'作業期間中'">
										<template v-slot:value>
											<template v-if="type == 'edit'">
												<v-text-field v-model="TODO" hide-details dense outlined />
											</template>
											<template v-else-if="type == 'show'">{{ "XXXXXXX" }}</template>
										</template>
									</ShowDetailRecord>
									<ShowDetailRecord :columnName="'立会、帰任時'">
										<template v-slot:value>
											<template v-if="type == 'edit'">
												<v-text-field v-model="TODO" hide-details dense outlined />
											</template>
											<template v-else-if="type == 'show'">{{ "XXXXXX" }}</template>
										</template>
									</ShowDetailRecord>
									<ShowDetailRecord :columnName="'品質、工期、作業者の対応'">
										<template v-slot:value>
											<template v-if="type == 'edit'">
												<v-text-field v-model="TODO" hide-details dense outlined />
											</template>
											<template v-else-if="type == 'show'">{{ "XXXXXXX" }}</template>
										</template>
									</ShowDetailRecord>
								</tbody>
							</table>
						</v-col>
					</v-row>
				</v-sheet>
			</v-tab-item>

			<v-tab-item>
				<h6 class="text-body-1 font-weight-bold">作業時間</h6>
				<div class="table-container mt-4 pb-4">
					<table>
						<tbody>
							<tr>
								<th colspan="2">工事責任者</th>
								<td colspan="3" class="border-top border-right">
									<v-text-field v-if="type == 'edit'" v-model="TODO" dense outlined hide-details />
									<template v-else-if="type == 'show'">XX XX</template>
								</td>
							</tr>
							<tr>
								<td colspan="2"></td>
								<th :style="width(200)">氏名</th>
								<td
									class="border-top"
									:style="width(240)"
									colspan="3"
									v-for="worker in workers()"
									:key="worker.id"
								>
									<v-text-field v-if="type == 'edit'" v-model="TODO" dense outlined hide-details />
									<template v-else-if="type == 'show'"> XX XX</template>
								</td>
							</tr>
							<tr>
								<th class="border-left" :style="width(50)">日</th>
								<th :style="width(50)">曜</th>
								<th>作業内容</th>
								<template v-for="worker in workers()">
									<th :style="width(80)" :key="`start-${worker.id}`">始業</th>
									<th :style="width(80)" :key="`end-${worker.id}`">終業</th>
									<th :style="width(80)" :key="`over-${worker.id}`">残業</th>
								</template>
							</tr>
							<!-- NOTE: trから別コンポーネントでもOK  -->
							<tr v-for="(date, i) in working_days()" :key="date.id">
								<td>{{ i + 1 }}</td>
								<td>{{ weekDay(date.date) }}</td>
								<td>
									<v-textarea
										auto-grow
										rows="1"
										v-if="type == 'edit'"
										v-model="TODO"
										dense
										outlined
										hide-details
									/>
									<template v-else-if="type == 'show'">XXXX</template>
								</td>

								<template v-for="worker in workers()">
									<td :key="`start-${worker.id}-${date}`">
										<v-text-field
											v-if="type == 'edit'"
											v-model="TODO"
											type="time"
											dense
											outlined
											hide-details
										/>
										<template v-else-if="type == 'show'">XX:XX</template>
									</td>
									<td :key="`end-${worker.id}-${date}`">
										<v-text-field
											v-if="type == 'edit'"
											v-model="TODO"
											type="time"
											dense
											outlined
											hide-details
										/>
										<template v-else-if="type == 'show'">XX:XX</template>
									</td>
									<td :key="`over-${worker.id}-${date}`" class="border-right">
										<v-text-field
											v-if="type == 'edit'"
											v-model="TODO"
											dense
											outlined
											hide-details
											suffix="H"
										/>
										<template v-else-if="type == 'show'">XX:XX</template>
									</td>
								</template>
							</tr>
						</tbody>
					</table>
				</div>
			</v-tab-item>
		</v-tabs-items>
	</v-sheet>
</template>

<script>
import axios from "axios"
import moment from "moment"
import "moment/locale/ja"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import common from "../../../helper/common"
import rules from "../../../helper/rules"
import ShowDetailRecord from "../../shared/ShowDetailRecord.vue"

export default {
	props: {
		construction_data: {
			type: Object,
			required: true,
		},
		type: {
			type: String,
			required: true,
		},
	},
	components: {
		ShowDetailRecord,
	},
	data() {
		return {
			tab: 0,
			TODO: "",
			common,
			rules,
		}
	},
	methods: {
		weekDay(date) {
			const dayOfWeek = ["日", "月", "火", "水", "木", "金", "土"]
			return dayOfWeek[moment(date).day()]
		},
		width(width) {
			return { width: width + "px", minWidth: width + "px", maxWidth: width + "px" }
		},
		reportByWorker(worker) {
			// TODO
		},
		workers() {
			// TODO
			return [{ id: 1 }, { id: 2 }, { id: 3 }]

			return []
		},
		working_days() {
			return [
				{ date: "2023-06-11" },
				{ date: "2023-06-12" },
				{ date: "2023-06-13" },
				{ date: "2023-06-14" },
				{ date: "2023-06-15" },
				{ date: "2023-06-16" },
			]
			// TODO
			return []
		},
	},
	computed: {
		construction: {
			get() {
				return this.construction_data
			},
			set(value) {
				this.$emit("update:construction_data", value)
			},
		},
	},
}
</script>

<style lang="scss" scoped>
.show-dialog-table {
	width: 100%;
}
.table-container {
	th {
		padding: 4px;
		font-weight: bold;
		background-color: whitesmoke;
		border-bottom: white solid 1px;
		&:not(:first-child) {
			border-left: white solid 1px;
		}
	}
	td {
		padding: 4px;
		// background-color: whitesmoke;
		border-bottom: whitesmoke solid 1px;
		&:not(:first-child) {
			border-left: whitesmoke solid 1px;
		}
	}
	.border-top {
		border-top: whitesmoke solid 1px;
	}
	.border-left {
		border-left: whitesmoke solid 1px;
	}
	.border-right {
		border-right: whitesmoke solid 1px;
	}
}
</style>